import React from 'react';
import { Box, Typography, Alert } from '@mui/material';

const SimpleAnalyticsPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Analytics
      </Typography>
      <Alert severity="info">
        Analytics page is being updated to use service account APIs. 
        Check the Ratings page for working analytics in the meantime!
      </Alert>
    </Box>
  );
};

export default SimpleAnalyticsPage;



